<app-modal
  #modal
  [modalConfig]="{
    titleText: 'Edit Level Names',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    customFooter: true,
    closeOnBgClick: true
  }"
  (isDismissing)="closeModal()">
  <button
    [disabled]="isUpdating"
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="closeModal()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <div class="container">
    <div *ngIf="isUpdating">
      <div class="w-100 is-updating-container">
        <app-loader [text]="'Updating'"></app-loader>
      </div>
    </div>
    <ng-container
      *ngIf="!isUpdating && levelNames && levelForm && modal.isOpen">
      <form [formGroup]="levelForm">
        <div class="input-group">
          <label for="level1" class="form-label level-name">Level 1</label>
          <input
            formControlName="level1"
            type="text"
            class="form-control"
            id="level1"
            aria-label="Level 1"
            [ngClass]="{
              'is-invalid': levelFormSubmitted && f['level1'].errors
            }" />
        </div>
        <div class="input-group">
          <label for="level2" class="form-label level-name">Level 2</label>
          <input
            formControlName="level2"
            type="text"
            class="form-control"
            id="level2"
            aria-label="Level 2"
            [ngClass]="{
              'is-invalid': levelFormSubmitted && f['level2'].errors
            }" />
        </div>
        <div *ngIf="levelNames.length >= 3" class="input-group">
          <label for="level3" class="form-label level-name">Level 3</label>
          <input
            formControlName="level3"
            type="text"
            class="form-control"
            id="level3"
            aria-label="Level 3"
            [ngClass]="{
              'is-invalid': levelFormSubmitted && f['level3'].errors
            }" />
        </div>
        <div *ngIf="levelNames.length >= 4" class="input-group">
          <label for="level4" class="form-label level-name">Level 4</label>
          <input
            formControlName="level4"
            type="text"
            class="form-control"
            id="level4"
            aria-label="Level 4"
            [ngClass]="{
              'is-invalid': levelFormSubmitted && f['level4'].errors
            }" />
        </div>
        <div *ngIf="levelNames.length >= 5" class="input-group">
          <label for="level5" class="form-label level-name">Level 5</label>
          <input
            formControlName="level5"
            type="text"
            class="form-control"
            id="level5"
            aria-label="Level 5"
            [ngClass]="{
              'is-invalid': levelFormSubmitted && f['level5'].errors
            }" />
        </div>
      </form>
    </ng-container>
  </div>

  <div footerContent>
    <div class="d-flex justify-content-between align-items-center">
      <button type="button" class="btn" (click)="closeModal()">Cancel</button>
      <button
        [disabled]="isUpdating"
        type="submit"
        class="btn btn-md btn-primary"
        (click)="onSubmit()">
        <ng-container *ngIf="isUpdating">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </ng-container>
        Update
      </button>
    </div>
  </div>
</app-modal>
